import React, { useEffect, useState } from 'react';
import './BarraRating.css';
import { CaretDownOutlined } from '@ant-design/icons';
import { Skeleton } from 'antd';
function BarraRating({ moco, loading, areaMunData }) {

    const array = [
        {
            id: 0,
            name: "AAA",
            color: '#1c4a16',
            activated: false,
            style: null
        },
        {
            id: 1,
            name: "AA+",
            color: '#34641c',
            activated: false,
            style: null
        },
        {
            id: 2,
            name: "AA",
            color: '#4c7f22',
            activated: false,
            style: null
        },
        {
            id: 3,
            name: "AA-",
            color: '#659928',
            activated: false,
            style: null
        },
        {
            id: 4,
            name: "A+",
            color: '#84a720',
            activated: false,
            style: null
        },
        {
            id: 5,
            name: "A",
            color: '#a4b617',
            activated: false,
            style: null
        },
        {
            id: 6,
            name: "A-",
            color: '#c3c50f',
            activated: false,
            style: null
        },
        {
            id: 7,
            name: "BBB+",
            color: '#e3d407',
            activated: false,
            style: null
        },
        {
            id: 8,
            name: "BBB",
            color: '#ffdf00',
            activated: false,
            style: null
        },
        {
            id: 9,
            name: "BBB-",
            color: '#fec400',
            activated: false,
            style: null
        },
        {
            id: 10,
            name: "BB+",
            color: '#fda900',
            activated: false,
            style: null
        },
        {
            id: 11,
            name: "BB",
            color: '#fb8e00',
            activated: false,
            style: null
        },
        {
            id: 12,
            name: "BB-",
            color: '#fa7300',
            activated: false,
            style: null
        },
        {
            id: 13,
            name: "B+",
            color: '#f85900',
            activated: false,
            style: null
        },
        {
            id: 14,
            name: "B",
            color: '#f73e00',
            activated: false,
            style: null
        },
        {
            id: 15,
            name: "B-",
            color: '#f52300',
            activated: false,
            style: null
        },
        {
            id: 16,
            name: "CCC",
            color: '#f40800',
            activated: false,
            style: null
        },
        {
            id: 17,
            name: "CC",
            color: '#c80000',
            activated: false,
            style: null
        },
        {
            id: 18,
            name: "C",
            color: '#880000',
            activated: false,
            style: null
        },
        {
            id: 19,
            name: "D",
            color: '#490000',
            activated: false,
            style: null
        },
    ]

    const [selected, setSelected] = useState(array);

    useEffect(() => {
        if (moco !== null && moco !== undefined && moco.valorRating !== undefined && areaMunData !== false) {
            const arrayTmp = array.map((objeto) => ({ ...objeto }));
            const valorRating = moco.valorRating;
            const index = arrayTmp.findIndex((objeto) => objeto.name === valorRating);
            let min=0;
            let max=0;
            for (let index = 0; index < areaMunData.length; index++) {
                const element = areaMunData[index];
                if( element.data[0] > 0 && min === 0) min = index;
                if( element.data[0] > 0) max = index;
            }

            const indexMaxBarrio = arrayTmp.findIndex((objeto) => objeto.id === 19-max);
            const indexMinBarrio = arrayTmp.findIndex((objeto) => objeto.id === 19-min);
            

            arrayTmp[indexMaxBarrio].activated = true;
            arrayTmp[indexMaxBarrio].style = { zIndex: 1, color: 'red' };

            arrayTmp[indexMinBarrio].activated = true;
            arrayTmp[indexMinBarrio].style = { zIndex: 1, color: 'red' };

            /*if( index <= 2) { //desbordado izq
                arrayTmp[index+3].activated = !arrayTmp[index].activated 
                arrayTmp[index+3].style = {zIndex: 1, color: 'red'};
                if(index === 2 ) {
                    arrayTmp[index-2].activated = !arrayTmp[index].activated
                    arrayTmp[index-2].style = {zIndex: 1, color: 'red'};
                }
                else if(index === 1 ) {
                    arrayTmp[index-1].activated = !arrayTmp[index].activated;
                    arrayTmp[index-1].style = {zIndex: 1, color: 'red'};
                }
                else {
                }
            } else if ( index >= 17 ) { //desbordado drch
                arrayTmp[index-3].activated = !arrayTmp[index].activated;
                arrayTmp[index-3].style = {zIndex: 1, color: 'red'};
                if(index === 17 ){
                    arrayTmp[index+2].activated = !arrayTmp[index].activated;
                    arrayTmp[index+2].style = {zIndex: 1, color: 'red'};
                } 
                else if(index === 18 ){
                    arrayTmp[index+1].activated = !arrayTmp[index].activated;
                    arrayTmp[index+1].style = {zIndex: 1, color: 'red'};
                } 
                else {
                }
            } else { //all ok
                arrayTmp[index+3].activated = !arrayTmp[index].activated;
                arrayTmp[index+3].style = {zIndex: 1, color: 'red'};
                arrayTmp[index-3].activated = !arrayTmp[index].activated;
                arrayTmp[index-3].style = {zIndex: 1, color: 'red'};
            }*/
            arrayTmp[index].activated = true;
            setSelected(arrayTmp);
        }
    }, [/*moco, */areaMunData])



    const barra = selected.map((item) => {
        let logicaPunteros
        let estilo = item.style
        if (item.activated === true) {
            logicaPunteros = estilo
        } else {
            logicaPunteros = { zIndex: -1 }
        }

        return (
            <div className='displayBarras' key={item.id}>
                <div className='pointer' style={logicaPunteros}>
                    <CaretDownOutlined />
                </div>
                <div className='boxes' style={{ backgroundColor: item.color }}>
                    {item.name}
                </div>
            </div>
        )
    })


    if (loading) {
        return (
            <div style={{ display: 'flex', gap: '5px', marginTop: '5%', marginLeft: '2%' }}>
                <Skeleton
                    active
                    loading={loading}
                    paragraph={{
                        rows: 3,
                    }}
                />
            </div>
        )
    } else {
        return (
            <div>
                <div className='contenedor'>
                    {barra}
                </div>
                <div className='leyenda-container'>
                    <h3 className='leyenda'><CaretDownOutlined /> Activo  <CaretDownOutlined style={{ color: 'red' }} /> Área Homogénea</h3>
                </div>
            </div>
        )
    }


   
}
export default BarraRating